import GENDERSALARYBYROLE from 'data/mantechcar24/gender-salary-by-role.json';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import React from 'react';
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const GenderSalaryByRole: React.FC = () => {
  const { t } = useI18n('developer-career-report-2024');
  const { locale } = useRouter();

  const genderSalaryByRole = GENDERSALARYBYROLE.sort((a, b) =>
    a.female > b.female ? -1 : 1
  );

  return (
    <div>
      <StyledRecharts className="gender xAxisLabel">
        <ResponsiveContainer height={750} width="99%" minWidth={700}>
          <BarChart data={genderSalaryByRole} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              tickFormatter={(tick) => {
                return `${tick / 1000}K`;
              }}
            ></XAxis>
            <YAxis
              type="category"
              dataKey="role"
              tickLine={false}
              width={200}
            />

            <Tooltip
              cursor={{ fill: '#d9ceff' }}
              labelStyle={{ display: 'none' }}
              separator=": "
              formatter={(value: number) => `${value.toLocaleString(locale)}€`}
              wrapperClassName="tooltip-x"
            />
            <Legend
              layout="horizontal"
              iconType="square"
              wrapperStyle={{ bottom: -5 }}
            />
            <Bar
              dataKey="female"
              name={t('mantechcar24.gender.females')}
              barSize={12}
              radius={5}
              fill="#974EA2"
            ></Bar>
            <Bar
              dataKey="male"
              name={t('mantechcar24.gender.males')}
              barSize={12}
              radius={5}
              fill="#7EAFD3"
            />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default GenderSalaryByRole;
